import { action, observable, runInAction } from 'mobx';
import { partnerClientsController } from './partnerClientsController';
import {
  CreatePartnerClientRequest,
  PartnerClient,
  GetPartnerClientsRequest,
  Client,
  CreateClientRequest,
  PartnerVehicleItemInterface,
} from './partnerClientsApi';

export interface PartnerClientsStore {
  partnerClients: PartnerClient[],
  partnerId: string, // по этому partnerId в partnerClients выбраны клиенты

  partnerVehicles: PartnerVehicleItemInterface[],
  partnerVehiclesById: string, // по этому partnerId в partnerVehicles выбраны авто партнёра

  error: string,
  discoveredClient: Client,
  currentPartnerClient: PartnerClient,
}

const initialValues: PartnerClientsStore = {
  partnerClients: [],
  partnerId: null,

  partnerVehicles: [],
  partnerVehiclesById: null,

  error: null,
  discoveredClient: null,
  currentPartnerClient: null,
};

export const partnerClientsStore = observable(initialValues);

export const partnerClientsActions = {
  handleError: (error: string) => {
    partnerClientsStore.error = error;
  },

  async getPartnerClientsByPartner(data: GetPartnerClientsRequest) {
    try {
      partnerClientsStore.partnerId = data.partnerId;
      const response = await partnerClientsController.getPartnerClientsByPartner(data);
      runInAction(() => {
        partnerClientsStore.partnerClients = response.data.items ?? [];
      });
    } catch (err) {
      this.handleError(err);
    }
  },

  async getVehiclesByPartner(data: GetPartnerClientsRequest) {
    try {
      partnerClientsStore.partnerVehiclesById = data.partnerId;
      const response = await partnerClientsController.getVehiclesByPartner(data);
      runInAction(() => {
        partnerClientsStore.partnerVehicles = response.data.items ?? [];
      });
    } catch (err) {
      this.handleError(err);
    }
  },

  getCurrentPartnerClient: async (id: string): Promise<void> => {
    const response = partnerClientsStore.partnerClients.find((v) => v.clientId === id);
    partnerClientsActions.setCurrentPartnerClient(response || null);
  },

  async createPartnerClient(data: CreatePartnerClientRequest) {
    try {
      await partnerClientsController.createPartnerClient(data);
    } catch (err) {
      this.handleError(err);
    }
  },

  async deletePartnerClient(clientId: string) {
    try {
      await partnerClientsController.deletePartnerClient(clientId);
    } catch (err) {
      this.handleError(err);
    }
  },

  async findClientByPhone(phoneNumber: string) {
    try {
       
      const response = await partnerClientsController.findClientByPhone(phoneNumber);
      runInAction(() => {
        partnerClientsStore.discoveredClient = response.data;
      });
    } catch (err) {
      this.handleError(err);
    }
  },

  setCurrentPartnerClient: action((partnerClient: PartnerClient) => {
    partnerClientsStore.currentPartnerClient = partnerClient;
  }),

  clearDiscoveredClient: action(() => {
    partnerClientsStore.discoveredClient = null;
    partnerClientsStore.error = null;
  }),

  async createClient(data: CreateClientRequest) {
    try {
      await partnerClientsController.createClient(data);
    } catch (err) {
      this.handleError(err);
    }
  },

};
